(() => {
  'use strict';

  const IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0741/7744/6049/files/max-flying-cursor-approved-transparent-v4.png?v=1784729848';
  const ROOT_ID = 'ary-max-cursor-v4';
  const DOT_CLASS = 'ary-max-dot-v4';
  const CURSOR_WIDTH = 72;
  const CURSOR_HEIGHT = 79;
  const CLICKABLE = 'a,button,input,select,textarea,label,summary,[role="button"],[onclick],[tabindex]:not([tabindex="-1"]),.button,.card,.product-card,.product-card-wrapper,product-card';

  const html = document.documentElement;

  if (typeof window.__aryMaxCursorV4Destroy === 'function') {
    window.__aryMaxCursorV4Destroy();
  }
  if (typeof window.__aryMaxCursorDestroy === 'function') {
    window.__aryMaxCursorDestroy();
  }

  const oldSelectors = [
    '#ary-max-cursor', '#max-cursor', '#max-follower', '#flying-max-cursor',
    '.max-cursor', '.max-follower', '.flying-max-cursor', '.cursor-character',
    '.cursor-candy', '.cursor-trail', '.max-trail', '.ary-cursor-trail',
    '.ary-max-trail', '.ary-max-particle', '.ary-max-candy',
    '.ary-max-falling-dot', '.ary-max-dot'
  ];

  function purgeOldCursorElements() {
    document.querySelectorAll(oldSelectors.join(',')).forEach((element) => element.remove());

    document.querySelectorAll('img').forEach((image) => {
      if (image.closest(`#${ROOT_ID}`)) return;

      const source = image.currentSrc || image.src || '';
      if (!/(max[-_ ]?(cursor|flying|follower)|ary[-_ ]?max[-_ ]?(cursor|flying)|flying[-_ ]?max)/i.test(source)) return;

      const style = getComputedStyle(image);
      const wrapper = image.closest('[id*="cursor" i],[class*="cursor" i],[id*="follower" i],[class*="follower" i]');
      if (wrapper || style.position === 'fixed') {
        (wrapper || image).remove();
      }
    });
  }

  purgeOldCursorElements();
  document.getElementById(ROOT_ID)?.remove();
  document.querySelectorAll(`.${DOT_CLASS}`).forEach((element) => element.remove());
  html.classList.remove('ary-max-active', 'ary-max-cursor-on', 'ary-max-v4-clickable');

  const disabled = matchMedia('(pointer: coarse)').matches ||
    innerWidth < 750 ||
    matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (disabled) return;

  html.classList.add('ary-max-v4-on');

  const cursor = document.createElement('div');
  cursor.id = ROOT_ID;
  cursor.setAttribute('aria-hidden', 'true');

  const character = document.createElement('span');
  character.className = 'ary-max-body-v4';

  const image = document.createElement('img');
  image.src = IMAGE_URL;
  image.alt = '';
  image.draggable = false;
  image.style.setProperty('--ary-max-facing', '1');

  character.appendChild(image);
  cursor.appendChild(character);
  document.body.appendChild(cursor);

  let targetX = -300;
  let targetY = -300;
  let currentX = -300;
  let currentY = -300;
  let previousX = -300;
  let previousY = -300;
  let angle = 0;
  let frame = 0;
  let lastDotAt = 0;
  let lastMoveAt = performance.now();
  let idleAmount = 0;
  let facing = 1;
  let clickable = false;
  let cleanupTimer = 0;

  const dotColors = ['#ff4f9a', '#ffd447', '#63d8ff', '#9c7cff', '#77e38f', '#ff8f45'];

  function addDot(x, y) {
    const now = performance.now();
    if (clickable || now - lastDotAt < 48) return;
    lastDotAt = now;

    const dot = document.createElement('i');
    dot.className = DOT_CLASS;

    const size = 2.5 + Math.random() * 3.5;
    const color = dotColors[Math.floor(Math.random() * dotColors.length)];

    dot.style.left = `${x + 12 + Math.random() * 11}px`;
    dot.style.top = `${y + 14 + Math.random() * 10}px`;
    dot.style.setProperty('--dot-size', `${size}px`);
    dot.style.setProperty('--dot-color', color);
    dot.style.setProperty('--dot-drift', `${-13 + Math.random() * 26}px`);
    dot.style.setProperty('--dot-fall', `${42 + Math.random() * 38}px`);
    dot.style.setProperty('--dot-time', `${620 + Math.random() * 330}ms`);

    document.body.appendChild(dot);
    setTimeout(() => dot.remove(), 1100);
  }

  function onMouseMove(event) {
    previousX = targetX;
    previousY = targetY;
    targetX = event.clientX;
    targetY = event.clientY;
    lastMoveAt = performance.now();

    const deltaX = targetX - previousX;
    if (Math.abs(deltaX) > 2.5) {
      facing = deltaX < 0 ? 1 : -1;
      image.style.setProperty('--ary-max-facing', String(facing));
    }

    clickable = Boolean(event.target.closest(CLICKABLE));
    html.classList.toggle('ary-max-v4-clickable', clickable);
    cursor.classList.toggle('is-clickable', clickable);
    cursor.classList.add('is-visible');

    const distance = Math.hypot(targetX - previousX, targetY - previousY);
    if (distance > 2) addDot(previousX, previousY);
  }

  function onMouseLeave() {
    cursor.classList.remove('is-visible');
    html.classList.remove('ary-max-v4-clickable');
  }

  function animate(now) {
    const velocityX = targetX - currentX;
    currentX += velocityX * 0.28;
    currentY += (targetY - currentY) * 0.28;

    const desiredAngle = Math.max(-10, Math.min(10, velocityX * 0.07));
    angle += (desiredAngle - angle) * 0.16;

    const idleTarget = now - lastMoveAt > 280 ? 1 : 0;
    idleAmount += (idleTarget - idleAmount) * 0.06;

    const idleX = Math.sin(now * 0.0021) * 1.4 * idleAmount;
    const idleY = Math.sin(now * 0.0030) * 3.1 * idleAmount;
    const idleRotate = Math.sin(now * 0.0017) * 1.8 * idleAmount;
    const idleScale = 1 + Math.sin(now * 0.0038) * 0.009 * idleAmount;

    character.style.transform = `translate3d(${idleX}px, ${idleY}px, 0) rotate(${idleRotate}deg) scale(${idleScale})`;
    cursor.style.transform = `translate3d(${currentX - CURSOR_WIDTH / 2}px, ${currentY - CURSOR_HEIGHT / 2}px, 0) rotate(${angle}deg)`;
    frame = requestAnimationFrame(animate);
  }

  function destroy() {
    cancelAnimationFrame(frame);
    clearInterval(cleanupTimer);
    observer.disconnect();
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseleave', onMouseLeave);
    cursor.remove();
    document.querySelectorAll(`.${DOT_CLASS}`).forEach((element) => element.remove());
    html.classList.remove('ary-max-v4-on', 'ary-max-v4-clickable');
    delete window.__aryMaxCursorV4Destroy;
  }

  image.addEventListener('error', destroy, { once: true });
  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseleave', onMouseLeave, { passive: true });

  const observer = new MutationObserver(() => purgeOldCursorElements());
  observer.observe(document.body, { childList: true, subtree: true });

  cleanupTimer = setInterval(purgeOldCursorElements, 700);
  setTimeout(() => clearInterval(cleanupTimer), 12000);

  frame = requestAnimationFrame(animate);
  window.__aryMaxCursorV4Destroy = destroy;
})();
